import { useEditorState } from 'platejs/react';

import { ToolbarButton } from './ToolbarButton';

export const ToolbarBlockButton = ({
  icon: Icon,
  type,
  inactiveType: _inactiveType,
  disabledOnActive,
  onClick,
  'aria-label': ariaLabel,
}: {
  icon: React.ComponentType;
  type: string;
  inactiveType?: string;
  disabledOnActive?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  'aria-label'?: string;
}) => {
  const editor = useEditorState();

  const active = !!editor?.selection && editor.api.some({ match: { type } });

  return (
    <ToolbarButton
      active={active}
      disabled={disabledOnActive && active}
      onClick={
        onClick
          ? onClick
          : (e: React.MouseEvent<HTMLButtonElement>) => {
              e.preventDefault();
              e.stopPropagation();

              editor.tf.toggleBlock(type);
              editor.tf.focus();
            }
      }
      aria-label={ariaLabel}
    >
      <Icon />
    </ToolbarButton>
  );
};
